import httpPortal from './http-portal'

class Worker {
  jobStatus (jobID) {
    return httpPortal.get(`/private/worker/data/${jobID}`)
  }
}

export default new Worker()



// WEBPACK FOOTER //
// ./src/services/worker.js